// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/work_step_group.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_work_step } from "./work_step_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/work_step_group.proto.
 */
export const file_studyo_today_planners_v1_resources_work_step_group = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3dvcmtfc3RlcF9ncm91cC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJpCg1Xb3JrU3RlcEdyb3VwEhcKD3BsYW5uZWRfd29ya19pZBgBIAEoCRI7CgVzdGVwcxgCIAMoCzIsLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuV29ya1N0ZXA6AhgBQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_planners_v1_resources_work_step]);

/**
 * Describes the message studyo.today.planners.v1.resources.WorkStepGroup.
 * Use `create(WorkStepGroupSchema)` to create a new message.
 * @deprecated
 */
export const WorkStepGroupSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_work_step_group, 0);

